/*
  ドロワーを出てきた方向へスワイプして閉じる(2026-09-07)
  対象はページ内の drawer-component すべて。メニュー・カート(テーマ標準)と
  商品・読みもの・マイメニュー(自作)で操作を揃える。片方だけ動くと迷うため。

  ・向きはクラスから決める(f-drawer--left=左 / cec-bdrawer=下 / それ以外=右)
  ・指の動きにパネルが付いてきて、暗幕の濃さも連動する
  ・画面の25%以上動く、または勢いよく振ったら閉じる。足りなければ元に戻す
  ・縦に動いた時は一覧のスクロールを優先。下から出るシートは一番上にいる時だけ拾う
  ・10px 動いて初めてドラッグ扱い。タップは今までどおり
*/
(function () {
  'use strict';

  var host = document.querySelector('[data-cec-swipe]');
  if (!host) return;
  if (host.getAttribute('data-enabled') !== 'true') return;

  var SHOW_GRAB = host.getAttribute('data-grab') === 'true';
  var HINT = host.getAttribute('data-hint') === 'true';
  var HINT_KEY = 'cec_drawer_hint';
  var START = 10; /* ここから先をドラッグとみなす */
  var RATIO = 0.25; /* この割合を超えたら閉じる */
  var FLICK = 0.5; /* px/ms。これより速ければ距離が足りなくても閉じる */

  function dirOf(d) {
    if (d.classList.contains('cec-bdrawer')) return 'down';
    if (d.classList.contains('f-drawer--left')) return 'left';
    return 'right';
  }

  /* 2026-10-06 横にスクロールできる列(最近見た商品のカード等)の上で始まった操作は列のスクロールに任せる。
     ここを拾うと、カードを送ろうとしただけでドロワーが閉じてしまう */
  function inHScroller(el, drawer) {
    while (el && el !== drawer && el.nodeType === 1) {
      if (el.scrollWidth > el.clientWidth + 1) {
        var ox = window.getComputedStyle(el).overflowX;
        if (ox === 'auto' || ox === 'scroll') return true;
      }
      el = el.parentNode;
    }
    return false;
  }

  function setup(drawer) {
    if (drawer.dataset.cecSwipe === '1') return;
    drawer.dataset.cecSwipe = '1';

    var dir = dirOf(drawer);
    drawer.setAttribute('data-cec-dir', dir);

    var overlay = drawer.querySelector('.f-drawer__overlay');
    var scroller = drawer.querySelector('.scroll-container, .f-drawer__scroller');

    if (SHOW_GRAB && !drawer.querySelector('.cec-grab') && dir !== 'down') {
      var g = document.createElement('span');
      g.className = 'cec-grab';
      g.setAttribute('aria-hidden', 'true');
      (drawer.querySelector('.f-drawer__content') || drawer).appendChild(g);
    }

    var sx = 0, sy = 0, st = 0, delta = 0, dragging = false, decided = false;

    function size() {
      var r = drawer.getBoundingClientRect();
      return dir === 'down' ? r.height : r.width;
    }

    function move(px) {
      var v = dir === 'left' ? -px : px;
      drawer.style.transition = 'none';
      drawer.style.transform =
        dir === 'down' ? 'translate3d(0,' + v + 'px,0)' : 'translate3d(' + v + 'px,0,0)';
      if (overlay) {
        overlay.style.transition = 'none';
        overlay.style.opacity = String(Math.max(0, 1 - px / size()));
      }
    }

    function release(close) {
      drawer.style.transition = '';
      drawer.style.transform = '';
      if (overlay) {
        overlay.style.transition = '';
        overlay.style.opacity = '';
      }
      if (close && typeof drawer.closeDrawer === 'function') drawer.closeDrawer();
    }

    drawer.addEventListener(
      'touchstart',
      function (e) {
        if (!drawer.hasAttribute('open') || e.touches.length !== 1) return;
        if (dir !== 'down' && inHScroller(e.target, drawer)) {
          st = 0;
          dragging = false;
          return;
        }
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        st = Date.now();
        delta = 0;
        dragging = false;
        decided = false;
      },
      { passive: true }
    );

    drawer.addEventListener(
      'touchmove',
      function (e) {
        if (!drawer.hasAttribute('open') || st === 0) return;
        var dx = e.touches[0].clientX - sx;
        var dy = e.touches[0].clientY - sy;

        if (!decided) {
          if (Math.abs(dx) < START && Math.abs(dy) < START) return;
          decided = true;
          if (dir === 'down') {
            /* 下から出るシートは、一覧が一番上にある時だけ引き下げを拾う */
            dragging = dy > 0 && Math.abs(dy) > Math.abs(dx) && (!scroller || scroller.scrollTop <= 0);
          } else {
            dragging = Math.abs(dx) > Math.abs(dy);
          }
          if (!dragging) st = 0;
          return;
        }
        if (!dragging) return;

        var raw = dir === 'left' ? -dx : dir === 'right' ? dx : dy;
        delta = Math.max(0, raw);
        move(delta);
      },
      { passive: true }
    );

    function end() {
      if (!dragging) { st = 0; return; }
      var far = delta > size() * RATIO;
      var fast = delta > 24 && delta / Math.max(1, Date.now() - st) > FLICK;
      dragging = false;
      st = 0;
      release(far || fast);
    }

    drawer.addEventListener('touchend', end);
    drawer.addEventListener('touchcancel', end);

    /* 初回だけ、開いた瞬間に軽く動かして「掴める」ことを伝える */
    drawer.addEventListener('open', function () {
      if (!HINT) return;
      var seen = false;
      try { seen = localStorage.getItem(HINT_KEY) === '1'; } catch (err) {}
      if (seen) return;
      try { localStorage.setItem(HINT_KEY, '1'); } catch (err) {}
      window.setTimeout(function () {
        if (!drawer.hasAttribute('open')) return;
        drawer.classList.add('cec-hint');
        window.setTimeout(function () { drawer.classList.remove('cec-hint'); }, 620);
      }, 420);
    });
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('drawer-component'), setup);
  }

  scan();
  /* テーマは drawer-component を body へ移すので、後から現れる分も拾う */
  window.setTimeout(scan, 800);
  window.setTimeout(scan, 2500);
})();
